import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Spinner,
  Tip,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Console,
  Video,
  Close,
  CodeSandbox,
  Gateway,
  Codepen,
} from "grommet-icons";
import axios from "axios";
import { hpe as theme } from "grommet-theme-hpe";
import auth from "./Security/Auth";
import {
  callApiGetJson,
  callApiPostJson,
  OnDemandRefreshInterval,
} from "./GlobalSettings";
import LiveDemoDetail from "./LiveDemoDetail";
import ContentDetailViewCard from "./ContentDetailViewCard";
import Rating from "@material-ui/lab/Rating";
import DatumContainer from "./DatumContainer";
import ScaleLoader from "react-spinners/ScaleLoader";

class DemoListView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Demo: this.props._demo,
      bShowDemoDetail: false,
      rateVal: 1,
      showLoaderRating: false,
    };
    this._showDemoDetail = this._showDemoDetail.bind(this);
    this._hideDemoDetail = this._hideDemoDetail.bind(this);
    this.setRating = this.setRating.bind(this);
  }

  componentDidMount() {
    this.setState({ Demo: this.props._demo });
    console.log("DemoLV Component Did Mount called");
    // console.log("Rating Mounted with ", this.state.Demo);
  }

  componentDidUpdate() {
    //this.setState({ Demo: this.props._demo });
    console.log("DemoLV Component Did Update called");
  }

  _showDemoDetail() {
    //console.log("Show dmo Det clicked with data passed as ", data);
    this.setState({ bShowDemoDetail: true });
  }
  _hideDemoDetail() {
    this.setState({ bShowDemoDetail: false });
    this.props.hide();
    // this.props.RefreshCallback();
  }

  setRating(newRate, type, id, rating) {
    console.log("Rating Prop is ", this.props._demo);
    console.log("Rating new Values is ", newRate);
    console.log("Rating new Values Type ", type);
    console.log("Rating new Values ID ", id);
    console.log("Rating  Curent Rate is ", rating);

    if (newRate !== null) {
      // console.log("Rating content Index Val is ", this.props.indexval);

      // var tempdemoData  = this.state.Demo;
      var ActionType = "";
      if (this.props._demo.Content_Rating > 0) {
        ActionType = "Update";
      } else {
        ActionType = "Insert";
      }

      var RatingDataPost = {
        Rating_ID: null,
        ContentId: id,
        Rating_Value: newRate,
        Action_Type: ActionType,
        Content_Type: type,
      };

      var endpoint = "/AllContent/AddorUpdateRating";
      let token = auth.getToken();
      var postData = RatingDataPost;
      console.log("Rating Data is :", RatingDataPost);
      this.setState({ showLoaderRating: true });
      //start below
      callApiPostJson(endpoint, postData, token).then((data) => {
        console.log(
          "Profile result Rating insert update response from API:",
          data
        );
        if (data) {
          console.log("UpdateMessage back from Rating Call response is : ");
          console.log(data);

          //  this.props.hide();
          var tempdemoData = this.state.Demo;

          if (tempdemoData != undefined) {
            tempdemoData.Content_Rating = newRate;
            /*           tempdemoData.map((demoitem) => {
            if(demoitem.Content_ID == contentID){
              demoitem.Content_Rating = newRate;
            }
          }); */
            this.setState({ Demo: tempdemoData, showLoaderRating: false });
          }

          //this.setState({ Demo: tempdemoData, showLoaderRating: false });
          // auth.updateUserInfo(data);
          // this.props.hidenaa();
          // this.props.history.push("/home");
          //this.props.router.replace("/home");
        }
      });
    } else {
      console.log(
        "No Action - As rating value not changed from previous value"
      );
    }
  }

  // this.setState({ Demo: tempdemoData, showLoaderRating: false });
  // auth.updateUserInfo(data);
  //this.props.hide();
  // this.props.history.push("/home");
  //this.props.router.replace("/home");

  render() {
    // var _Demo = this.state.Demo ? this.state.Demo : this.props._demo;

    var _Demo = this.state.Demo ? this.state.Demo : this.props._demo; //this.props._demo;
    var bShowDetailPopup = false;
    bShowDetailPopup = this.state.bShowDemoDetail;
    var applicableDemo = undefined;
    // var raTingVal = this.state.rateVal;

    // console.log("From Demo Lists - State ", _Demo);
    console.log("From Demo Lists - Props ", this.props._demo);

    /* if (this.props.AllDemos) {
      applicableDemo = this.props.AllDemos.find(
        (dm) => dm.Content_ID === this.props._demo.Content_ID
      );
    } */

    var selColor = "green";

    if (this.props._type === "Live") {
      selColor = "green";
    }
    if (this.props._type === "Lab") {
      selColor = "graph-0";
    }
    if (this.props._type === "Interactive") {
      selColor = "graph-3";
    }

    //varIcon = "";

    return (
      <Box
        align="center"
        justify="between"
        direction="row-responsive"
        gap="medium"
        responsive={false}
      >
        <Box align="center" justify="start" direction="row">
          <Box
            align="center"
            justify="center"
            background={{ color: selColor }}
            pad="small"
            round="small"
          >
            {this.props._type === "Live" && (
              <Console color="black" size="large" />
            )}
            {this.props._type === "Lab" && (
              <Codepen color="black" size="large" />
            )}
            {this.props._type === "Interactive" && (
              <Gateway color="black" size="large" />
            )}
          </Box>
          <Box
            align="center"
            justify="start"
            direction="row"
            gap="small"
            pad="medium"
          >
            <Box align="stretch" justify="start" direction="column">
              <Text weight="bold" color="black">
                {_Demo.Content_Title}
              </Text>
              <Text weight="normal">
                {_Demo.PhyContent_Category !== null
                  ? _Demo.PhyContent_Category
                  : "Live - Demo"}
                {/* {_Demo.Content_Type === "Physical"
                  ? "Live-Demo"
                  : "Other Content"} */}
              </Text>
              <Text weight="normal" color="black">
                {_Demo.Content_ExpertiseLevel
                  ? _Demo.Content_ExpertiseLevel.ExpertLevelName
                  : "No Expertise"}
              </Text>
              <Text weight="normal" color="black">
                {_Demo.Content_Duration != null
                  ? _Demo.Content_Duration.substring(0, 8) + " (hh:mm:ss)"
                  : "00:00:00 (hh:mm:ss)"}
              </Text>
              {this.state.showLoaderRating && (
                <ScaleLoader
                  color="#008000"
                  height={20}
                  speedMultiplier={2}
                  width={5}
                />
              )}
              {!this.state.showLoaderRating && (
                <Rating
                  name={this.props._demo.Content_ID}
                  style={{ color: "green" }}
                  value={_Demo.Content_Rating} //{this.props._demo.Content_Rating}
                  onChange={(event, newvalue) => {
                    this.setRating(
                      newvalue,
                      this.props._demo.Content_Type,
                      this.props._demo.Content_ID,
                      this.props._demo.Content_Rating
                    );
                  }}
                />
              )}
              {/* <DatumContainer
                ddemo={this.props._demo}
                hidenaa={this.props.hide}
              /> */}
            </Box>
          </Box>
        </Box>
        <Box
          align="center"
          justify="end"
          direction="row"
          flex={false}
          pad={{ horizontal: "small" }}
          gap="xxsmall"
        >
          <Tip
            plain
            content={
              <Box
                pad="small"
                gap="small"
                width={{ max: "small" }}
                round="small"
                background="background-front"
                responsive={false}
              >
                <Text weight="bold">Details</Text>
                <Text size="small">
                  Click to see details and Launch or Schedule Demo.
                </Text>
              </Box>
            }
            dropProps={{ align: { left: "right" } }}
          >
            <Button icon={<ScheduleNew />} onClick={this._showDemoDetail} />
          </Tip>
          {/*               {_Demo.Is_DemoReady ? (
                <Button
                  label="launch"
                  primary={false}
                  secondary
                  // onClick={() => push("/launchdemospinner")}
                />
              ) : (
                <Button
                  label="launch"
                  primary={false}
                  secondary
                  disabled={true}
                  // onClick={() => push("/launchdemospinner")}
                />
              )}
              <Button label="schedule" primary={false} /> */}
          {/*           <Button
            label="Demo Guide"
            primary={false}
            secondary={false}
            reverse
          /> */}
        </Box>
        {bShowDetailPopup && (
          <LiveDemoDetail
            _demoData={_Demo}
            hide={this._hideDemoDetail}
            calledBy={this.props.calledBy}
          />
        )}
      </Box>
    );
  }
}

export default DemoListView;
